<template>
  <right-menu-item
    v-if="show"
    @click.prevent="click"
    :class="{ 'muted': !isActive }"
    :text="$t('Move to trash')"
    :loading="loading"
    icon="trash"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import trash from '../../mixins/actions/Trash'
import { trackEvent } from '../../gtm'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      if (this.bcFolderStore.current?.can_edit) {
        return true
      }
      
      return false
    },
    isActive () {
      return this.bcSelectedStore.listSelected.length > 0
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore),
  },
  methods: {
    async click() {
      this.loading = true
      const documents = this.bcSelectedStore.listSelected
        .filter(e => e.can_edit && e.type === 'document')
        .map(e => e.id)

      const folders = this.bcSelectedStore.listSelected
        .filter(e => e.can_edit && e.type === 'folder')
        .map(e => e.id)

      await trash(documents, folders)
      this.bcSelectedStore.reload()
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'trash')
    }
  }
}
</script>

<style lang="scss" scoped></style>
